/**
 * Normalize API date strings (YYYY-MM-DD or ISO datetime) to YYYY-MM-DD for comparisons.
 */
export function toYmd(value) {
  if (value == null || value === '') return '';
  const s = String(value).trim();
  return s.length >= 10 ? s.slice(0, 10) : s;
}

/** Multipart / JSON may send is_event as boolean, 1, or string. */
export function isEventTicketType(tt) {
  if (!tt) return false;
  const v = tt.is_event;
  return v === true || v === 1 || v === '1' || v === 'true' || v === 'True';
}
